SNI.Application.addModule('season-grid', context => {
  const debug = context.getService('logger').create('module.season-grid');
  const deviceType = context.getService('device-type');
  let behaviors = ['lazy-load'];
  let config = context.getConfig();
  let namespace = 'season-grid';
  let episodeSelector = `[data-${namespace}-episode]`;
  if (config && config.hasDropdown) {
    behaviors.push('replace-content');
  }
  if (deviceType.isMobile) {
    behaviors.push('load-more');
  }

  return {
    behaviors,
    init: () => { debug.log('init with behaviors: ' + behaviors); },
    onclick: function(event, element, elementType) {
      switch (elementType) {
        case 'recipe-label':
          const $episodeContainer = $(element).closest(`${episodeSelector}`);
          if ($episodeContainer.hasClass('selected')) {
            $episodeContainer.removeClass('selected');
          } else {
            //remove selected class from all other episodes
            $(`${episodeSelector}`).removeClass('selected');
            //Add the selected class to the clicked episode
            $episodeContainer.addClass('selected');
          }
          break;
      }
    }
  };
});
